<template>
  <div class="login-page" :class="{ 'dark-mode': isDarkMode }">
    <!-- Header 
    <header class="login-header">
      <div class="header-container">
        <div class="logo-section">
          <img v-if="businessLogo" :src="businessLogo" alt="Company Logo" class="company-logo"  height="10px" width="15px"/>
          <img v-else src="../../assets/images/ppt/pavicon_final_logo.png" alt="Pavicon Logo" class="company-logo" height="10px" width="15px" />
        </div>
        <div class="header-actions">
           Dark Mode Toggle 
          <div class="theme-toggle" @click="toggleDarkMode">
            <div class="toggle-switch" :class="{ active: isDarkMode }">
              <div class="toggle-slider">
                <svg v-if="!isDarkMode" class="toggle-icon sun-icon" viewBox="0 0 24 24" width="12" height="12">
                  <path fill="currentColor" d="M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8M12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18M20,8.69V4H15.31L12,0.69L8.69,4H4V8.69L0.69,12L4,15.31V20H8.69L12,23.31L15.31,20H20V15.31L23.31,12L20,8.69Z" />
                </svg>
                <svg v-else class="toggle-icon moon-icon" viewBox="0 0 24 24" width="12" height="12">
                  <path fill="currentColor" d="M17.75,4.09L15.22,6.03L16.13,9.09L13.5,7.28L10.87,9.09L11.78,6.03L9.25,4.09L12.44,4L13.5,1L14.56,4L17.75,4.09M21.25,11L19.61,12.25L20.2,14.23L18.5,13.06L16.8,14.23L17.39,12.25L15.75,11L17.81,10.95L18.5,9L19.19,10.95L21.25,11M18.97,15.95C19.8,15.87 20.69,17.05 20.16,17.8C19.84,18.25 19.5,18.67 19.08,19.07C15.17,23 8.84,23 4.94,19.07C1.03,15.17 1.03,8.83 4.94,4.93C5.34,4.53 5.76,4.17 6.21,3.85C6.96,3.32 8.14,4.21 8.06,5.04C7.79,7.9 8.75,10.87 10.95,13.06C13.14,15.26 16.1,16.22 18.97,15.95M17.33,17.97C14.5,17.81 11.7,16.64 9.53,14.5C7.36,12.31 6.2,9.5 6.04,6.68C3.23,9.82 3.34,14.4 6.35,17.41C9.37,20.43 14,20.54 17.33,17.97Z" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>-->

    <!-- Main Content -->
    <main class="login-main" >
      <div class="login-container">
        <div class="login-page-branding">
          <img src="../../assets/images/ppt/pavicon_login_ppt.png" alt="Pavicon Logo" class="login-logo login-logo-outside" />
        </div>
        <div class="login-form-wrapper">
          <form class="login-form">
            <!-- Module Selection 
            <div class="form-group">
              <select 
                v-model="selectModule" 
                class="form-input"
                required
              >
                <option disabled value="">Select module</option>
                <option value="warehouse">Warehouse</option>
                <option value="business-development">Business Development</option>
              </select>
            </div>-->

            <!-- Email Field -->
            <div class="form-group">
              <input 
                type="email" 
                v-model="email"
                placeholder="Enter email or username"
                class="form-input"
                required
              />
            </div>

            <!-- Password Field (only show when not in forgot password mode) -->
            <div class="form-group" v-if="!isForgotPassword">
              <input 
                type="password" 
                v-model="password"
                placeholder="Enter password"
                class="form-input"
                required
              />
            </div>

            <!-- Forgot Username Link -->
            <div class="forgot-username-wrapper" v-if="!isForgotPassword">
              <a href="#" @click.prevent="forgotPassword" class="forgot-username-link">
                Forgot password?
              </a>
            </div>

            <!-- Submit Button -->
            <div class="form-group">
              <button 
                type="button" 
                @click="isForgotPassword ? resetSubmit() : loginSubmit()"
                class="continue-btn "
                :disabled="loading"
                style="color: white !important;"
              >
                <span v-if="loading" class="btn-loading">
                  <span class="spinner" aria-hidden="true"></span>
                  <span class="loading-text">Please wait...</span>
                </span>
                <span v-else>
                  {{ isForgotPassword ? 'RESET PASSWORD' : 'SIGN IN' }}
                </span>
              </button>
            </div>

            <!-- Back to Login Link (only show in forgot password mode) -->
            <div class="back-to-login-wrapper" v-if="isForgotPassword">
              <a href="#" @click.prevent="forgotPassword" class="back-to-login-link">
                {{ ForgotPasswordText }}
              </a>
            </div>
          </form>

          <!-- Social Login Options (only show in login mode) -->
          <div class="social-login-section" v-if="!isForgotPassword">
             <!-- <div class="divider">
              <span class="divider-text">OR</span>
            </div>

          <div class="social-login-buttons">
              <button class="social-btn google-btn" type="button">
                <svg class="social-icon" viewBox="0 0 24 24" width="20" height="20">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                Login with Google
              </button>
            </div>-->


          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { useDarkMode } from '../../composables/useDarkMode'

export default {
  name: 'LoginPage',
  setup() {
    const { isDarkMode, toggleDarkMode } = useDarkMode()
    return {
      isDarkMode,
      toggleDarkMode
    }
  },
  data: () => ({
    LoginText: "Login",
    ForgotPasswordText: "Back to Login",
    isForgotPassword : false,
    email: "",
    password: "",
    user: "",
    selectModule:"",
    rules: [
        value => !!value || 'Required.',
        value => (value && value.length >= 4) || 'Min 4 characters',
    ],
    profile: {},
    businessLogo: "",
    systemName: "",
    loading: false
  }),

  mounted(){
    const profileData = localStorage.getItem('profile');
    this.profile = profileData && profileData !== 'undefined' ? JSON.parse(profileData) : null;
    this.businessLogo = this.profile?.businessLogo
    this.systemName = this.profile?.systemName
  },

  methods:{
    forgotPassword() {
      this.isForgotPassword = !this.isForgotPassword
      if(this.isForgotPassword) {
        this.LoginText = "Reset Password"
        this.ForgotPasswordText = "Back to Login"
      } else{
        this.LoginText = "Login"
        this.ForgotPasswordText = "Forgot Password?"
      }
    },

    async loginSubmit () {
      this.loading = true
      try {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ 
                email: this.email,
                password: this.password
            })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/auth/login', requestOptions)
        const data = await res.json()

        if(data.status == true){
            localStorage.setItem('access_token', JSON.stringify(data.access_token))
          localStorage.setItem('active_module', this.selectModule)
            // Also store token in a cookie for immediate availability to other parts of the app
            try {
              const cookieDays = 7;
              const d = new Date();
              d.setTime(d.getTime() + (cookieDays * 24 * 60 * 60 * 1000));
              const expires = 'expires=' + d.toUTCString();
              const secureFlag = location.protocol === 'https:' ? '; Secure' : '';
              document.cookie = 'access_token=' + encodeURIComponent(data.access_token) + '; ' + expires + '; path=/; SameSite=Lax' + secureFlag;
            } catch (e) {
              // ignore cookie write errors
            }
            await this.setupUser(data.access_token)
            return
        }

        Swal.fire({
            icon: 'error',
            title: 'Login failed',
            text: data.message
        })
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Login failed',
          text: err.message || 'Request failed'
        })
      } finally {
        this.loading = false
      }
    },

    async setupUser(token){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/users/profile', requestOptions)
        const data = await res.json()
        if(data.status == true){
          this.user = data.user;
          localStorage.setItem('permission', JSON.stringify(data.user.Permission))
          // navigate based on permissions
          this.loading = false
          if (this.selectModule === 'business-development') {
            this.$router.push('/admin/bid/analytics')
          } else if (this.selectModule === 'procurement') {
            this.$router.push('/admin/procurement/analytics')
          } else {
            if(this.user.Permission && this.user.Permission.dashboard)
              this.$router.push("/home")
            else if(this.user.Permission && this.user.Permission.transaction)
              this.$router.push("/transaction")
            else this.$router.push("/inventory/stocks")
          }
        }else{
          this.loading = false
          this.$router.push("/")
        }
    },

    async resetSubmit () {
      if(this.email == ""){
        Swal.fire({
          icon: 'error',
          title: 'Password Reset Failed',
          text: 'Enter an email address'
        })
        return false;
      }
      this.loading = true
      try {
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ 
                email: this.email
            })
        };
        const res = await fetch(process.env.VUE_APP_URL +'/auth/reset', requestOptions)
        const data = await res.json()
        if(data.status == true){
          Swal.fire({
              icon: 'success',
              title: 'Password Reset Successfully',
              text: data.message
          })
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Password Reset Failed',
                text: data.message
            })
        }
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Password Reset Failed',
          text: err.message || 'Request failed'
        })
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>
/* Reset and base styles */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.login-page {
  /* Light mode colors (default) */
  --bg-primary: #f8f9fa;
  --bg-secondary: #fff;
  --text-primary: #333;
  --text-secondary: #6c757d;
  --border-color: #e9ecef;
  --border-input: #ced4da;
  --shadow: rgba(0, 0, 0, 0.1);
  --accent-color: #007bff;
  --accent-hover: #0056b3;
  --button-primary: #ff6b35;
  --button-hover: #e55a2e;
  
  min-height: 100vh;
  background-color: var(--bg-primary);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
  display: flex;
  flex-direction: column;
  color: var(--text-primary);
  transition: background-color 0.3s ease, color 0.3s ease;
}

.login-page.dark-mode {
  /* Dark mode colors */
  --bg-primary: #1a1a1a;
  --bg-secondary: #2d2d2d;
  --text-primary: #e0e0e0;
  --text-secondary: #a0a0a0;
  --border-color: #404040;
  --border-input: #555;
  --shadow: rgba(0, 0, 0, 0.4);
  --accent-color: #4dabf7;
  --accent-hover: #339af0;
  --button-primary: #ff7849;
  --button-hover: #ff6b35;
}

/* Header Styles */
.login-header {
  background-color: var(--bg-secondary);
  border-bottom: 1px solid var(--border-color);
  padding: 0.5rem 0;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
}

.company-logo {
  height: 40px;
  width: auto;
  object-fit: contain;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Theme Toggle */
.theme-toggle {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;
}

.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: var(--border-input);
  border-radius: 11px;
  transition: background-color 0.3s ease;
  display: flex;
  align-items: center;
}

.toggle-switch.active {
  background-color: var(--accent-color);
}

.toggle-slider {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: var(--bg-secondary);
  border-radius: 50%;
  transition: transform 0.3s ease, background-color 0.3s ease;
  transform: translateX(2px);
  display: flex;
  align-items: center;
  justify-content: center;

}

.toggle-switch.active .toggle-slider {
  transform: translateX(22px);
}

.toggle-icon {
  transition: opacity 0.2s ease;
  color: var(--text-secondary);
}

.language-selector {
  color: var(--text-secondary);
  font-size: 13px;
  cursor: pointer;
}

.language-text {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Main Content */
.login-main {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 4.5rem 1rem 2rem;
}

.login-container {
  width: 100%;
  max-width: clamp(280px, 22vw, 360px);
}

.login-page-branding {
  display: flex;
  justify-content: center;
  margin-bottom: 0.9rem;
}

.login-form-wrapper {
  background: var(--bg-secondary);
  border-radius: 8px;
  padding: 1.9rem 1.75rem;
  /*box-shadow: 0 4px 10px var(--shadow), 0 1px 2px rgba(0, 0, 0, 0.1);*/
  border: 1px solid var(--border-color);
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Form Header */
.login-form-header {
  text-align: center;
  margin-bottom: 1.35rem;
}
/* System Branding */
.system-branding {
  margin-bottom: 1.1rem;
}

.login-logo {
  height: 20px;
  width: auto;
  margin-bottom: 0.6rem;
}

.login-logo-outside {
  margin-bottom: 0;
}

.system-name {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
}

.system-description {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0 0 1rem 0;
  font-weight: 400;
}
.login-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.signup-text {
  color: var(--text-secondary);
  font-size: 13px;
}

.signup-link {
  color: var(--accent-color);
  text-decoration: none;
  font-weight: 500;
}

.signup-link:hover {
  color: var(--accent-hover);
  text-decoration: underline;
}

/* Form Styles */
.login-form {
  width: 100%;
}

.form-group {
  margin-bottom: 0.85rem;
}

.form-input {
  width: 100%;
  padding: 11px 13px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
  font-size: 13px;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, background-color 0.3s ease;
}

.form-input:focus {
  border-color: var(--accent-color);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-input::placeholder {
  color: var(--text-secondary);
}

/* Loading spinner for buttons */
.btn-loading{ display:flex; align-items:center; gap:8px; justify-content:center }
.spinner{ width:13px; height:13px; border-radius:50%; border:2px solid rgba(255,255,255,0.3); border-top-color: #fff; animation: spin 0.8s linear infinite; display:inline-block }
.loading-text{ font-size:13px; color:#fff }
.continue-btn[disabled]{ opacity:0.7; cursor:not-allowed }

@keyframes spin{ to{ transform: rotate(360deg) } }

/* Select specific styles */
select.form-input {
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 11px center;
  background-repeat: no-repeat;
  background-size: 13px;
  padding-right: 40px;
  appearance: none;
}

/* Forgot username link */
.forgot-username-wrapper {
  text-align: left;
  margin-bottom: 1.15rem;
}

.forgot-username-link {
  color: #4f506e;
  font-size: 13px;
  text-decoration: none;
}

.forgot-username-link:hover {
  color: #4338ca;
  text-decoration: underline;
}

/* Continue Button */
.continue-btn {
  width: 100%;
  background-color: #4f506e;
  color: white;
  border: none;
  padding: 11px 24px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.continue-btn:hover {
  background-color: #4338ca;
}

.continue-btn:active {
  background-color: #3730a3;
}

/* Back to Login Link */
.back-to-login-wrapper {
  text-align: center;
  margin-top: 1rem;
}

.back-to-login-link {
  color: #4f506e;
  font-size: 13px;
  text-decoration: none;
}

.back-to-login-link:hover {
  color: #4338ca;
  text-decoration: underline;
}

/* Social Login Section */
.social-login-section {
  margin-top: 1.5rem;
}

.divider {
  display: flex;
  align-items: center;
  margin: 1.5rem 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-color);
}

.divider-text {
  margin: 0 1rem;
  color: var(--text-secondary);
  font-size: 13px;
  font-weight: 500;
}

.social-login-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.social-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 11px 13px;
  border: 1px solid var(--border-input);
  border-radius: 4px;
  background-color: var(--bg-secondary);
  color: var(--text-primary);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  text-decoration: none;
}

.social-btn:hover {
  background-color: var(--bg-primary);
  border-color: var(--border-color);
}

.social-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.google-btn {
  color: #4285f4;
}

.github-btn {
  color: var(--text-primary);
}

.sso-btn {
  color: var(--text-secondary);
}

/* Footer Styles */
.login-footer {
  background-color: var(--bg-secondary);
  border-top: 1px solid var(--border-color);
  padding: 1rem 0;
  margin-top: auto;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.copyright {
  color: var(--text-secondary);
  font-size: 13px;
  margin: 0;
}

.footer-links {
  display: flex;
  gap: 1.5rem;
}

.footer-link {
  color: var(--accent-color);
  font-size: 13px;
  text-decoration: none;
}

.footer-link:hover {
  color: var(--accent-hover);
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 1100px) {
  .login-form-wrapper {
    padding: 1.6rem 1.35rem;
  }
}

@media (max-width: 768px) {
  .header-container {
    padding: 0 1rem;
  }

  .login-main {
    padding-top: 3rem;
  }
  
  .login-form-wrapper {
    padding: 1.55rem 1.25rem;
    margin: 0 1rem;
  }
  
  .footer-container {
    padding: 0 1rem;
    flex-direction: column;
    text-align: center;
  }
  
  .footer-links {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .login-main {
    padding-top: 2rem;
  }

  .login-form-wrapper {
    padding: 1.3rem 0.95rem;
  }
  
  .login-title {
    font-size: 20px;
  }
  
  .continue-btn {
    font-size: 13px;
    padding: 10px 20px;
  }
}
</style>